export default __webpack_public_path__ + "static/illo-flower-clock-a5c3884200f1f3953cdc060a95f070b7.png";